/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var change_submit_forms = document.querySelectorAll('.js-change-submit');
  if(change_submit_forms) {
    change_submit_forms.forEach((change_submit_form) => {
      change_submit_form.addEventListener('change', () => {
        change_submit_form.submit();
      });
    });
  }

  var blog_form = document.querySelector('.js-blog-category');
  if(blog_form) {
    blog_form.addEventListener('change', (e) => {
      e.preventDefault();
      if(blog_form.querySelector('select').value.substring(0, 5) === '/blog') {
        location.href = blog_form.querySelector('select').value;
      }
    });
  }
}());